export default "__VITE_ASSET__Bw5lmEEo__"